import { ComponentRef, Directive, Input, OnChanges, OnInit, SimpleChanges, Type, ViewContainerRef } from "@angular/core";
import { ListingItemInterface } from "../../interfaces/listing-item.interface";

@Directive({
  selector: "[dynamicChildLoader]",
})
export class DynamicChildLoaderDirective<T> implements OnInit, OnChanges {
  /**
   * The component to be rendered
   */
  @Input() component?: Type<T>;
  @Input() inputs!: any;
  @Input() outputs!: any;
  @Input() visible?: ((row: any) => boolean) | boolean;

  @Input() row!: ListingItemInterface;

  createdComponentRef!: ComponentRef<T>;
  constructor(public viewContainerRef: ViewContainerRef) {}

  async ngOnInit() {}

  async ngOnChanges(changes: SimpleChanges) {
    if (this.visible !== undefined && !(typeof this.visible === "function" ? this.visible(this.row) : this.visible)) {
      return; // it should hide the component but for now this is enough
    }
    if (changes["component"]) {
      this.createComponent();
    }
    // The setTimeout is used to wait till the ngAfterViewInit is called.
    if (changes["inputs"]) {
      await this.updateInputs();
    }
    if (changes["outputs"]) {
      await this.updateOutputs();
    }
  }

  /**
   * Creates the components and assign its ref to this.createComponentRef
   */
  createComponent() {
    if (!this.component) {
      return;
    }
    this.createdComponentRef = this.viewContainerRef.createComponent(this.component!);
  }

  /**
   * Updates the component inputs.
   */
  async updateInputs() {
    if (!this.component) {
      return;
    }
    const inputs = typeof this.inputs === "function" ? await this.inputs(this.row) : (this.inputs ?? {});
    Object.keys(inputs).forEach(key => {
      this.createdComponentRef?.setInput(key, inputs[key]);
    });
  }

  /**
   * Updates the component outputs.
   */
  async updateOutputs() {
    if (!this.component) {
      return;
    }
    const instance = this.createdComponentRef?.instance;
    const outputs = typeof this.outputs === "function" ? await this.outputs(this.row, this.createdComponentRef) : (this.outputs ?? {});
    Object.assign(instance ?? {}, outputs);
  }
}
